import { ClientException, BaseState, BaseEntity } from '@base/entities/BaseEntities';
import { ComponentCustomization, FieldCustomizationElement, InjectableComponentOptions } from '@base/classes/BaseClasses';
import { Route } from '@angular/router';
import { BaseInjectableComponent } from '@m4u-angular/base/component/BaseInjectableComponent';
import { HttpContextToken } from '@angular/common/http';

class SysGlobalsClass {
    MainMenuVisible: boolean;
    MenuPath: string;
    PageStates: { [page: string]: BaseState } = {};
    IsResetState: boolean;
    LastException: ClientException;
    Language: string;
    CurrentEntity: BaseEntity;
    CurrentState: BaseState;
    FieldCustomizations: FieldCustomizationElement[];
    ComponentCustomizations: ComponentCustomization[];
    PageRoutes: Route[];
    NavigationSequence: number;
    ProgressPercent: number;
    IsProgressTracking: boolean;
    IgnoreSessionRefreshRequestToken: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);

    InjectableComponentsOptions: InjectableComponentOptions<BaseInjectableComponent<BaseEntity, BaseState>>[] = [];
}

export const SysGlobals = new SysGlobalsClass();
